<template>
  <!-- 数字增长容器 -->
  <div class="number-grow-warp">
    <!-- 使用 ref 引用数字增长元素，方便在 mounted 钩子函数中调用 -->
    <span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value">0</span>
  </div>
</template>
 
<script>
export default {
  props: {
    // 数字增长的时间，单位为秒，默认为 2 秒
    time: {
      type: Number,
      default: 5
    },
    // 数字增长的目标值，即最终显示的数字，默认为 2000
    value: {
      type: Number,
      default: 2000
    }
  },
  methods: {
    // 数字增长方法，接受一个数字增长元素作为参数
    numberGrow(ele) {
      let _this = this;
      let step = '';

      if (_this.value < 100) {
        step = (_this.value * 10) / (_this.time * 100);//每10毫秒增加的值
      } else if (_this.value >= 2000 &&_this.value <= 10000) {
  
        step = (_this.value * 10) / (_this.time * 10);//每10毫秒增加的值
      } else {
      
        step = (_this.value * 10) / (_this.time * 10);//每10毫秒增加的值
      }
      console.log(_this.value);
      // 计算每个时间片应该增加的数值
      let current = 0
      let start = 0
      // 设置计时器，每隔一定时间增加一定数值，直到达到目标值
      this.t = setInterval(function () {
        start += step;//+1或者+多少，数字太小不让滚
        // 如果达到目标值，清除计时器
        if (start > _this.value) {
          clearInterval(_this.t)
          start = _this.value
          _this.t = null
        }
        // 避免重复设置元素内容
        if (current === start) {
          return
        }
        current = start;
        
        // 将数字格式化为每三位加一个逗号的形式
        ele.innerHTML = (current.toFixed(3)).toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1')
      }, 10) // 每隔 10 毫秒增加一定数值
    }
  },
  mounted() {
    // 在组件挂载后，调用 numberGrow 方法，将数字增长元素作为参数传入
    this.numberGrow(this.$refs.numberGrow)
  },
  beforeDestroy() {
    // 在组件销毁前，清除计时器
    if (this.t) {
      clearInterval(this.t)
      this.t = null
    }
  }
}
</script>
 
<style>
.number-grow-warp {
  transform: translateZ(0);
}

.number-grow {
  font-family: Arial-BoldMT;
  font-size: 40px;
  color: #f89b19;
  letter-spacing: 2.67px;
}

.Num {
  margin-left: 20px;
}


/* .Num 类似的选择器没有在组件中使用，可以删除 */
</style>